import { render, staticRenderFns } from "./NavSteps.vue?vue&type=template&id=37f7cb27&scoped=true&"
import script from "./NavSteps.vue?vue&type=script&lang=js&"
export * from "./NavSteps.vue?vue&type=script&lang=js&"
import style0 from "./NavSteps.vue?vue&type=style&index=0&id=37f7cb27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f7cb27",
  null
  
)

export default component.exports